/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  serverUrl: 'https://beauty.remabackend.com/v1',
  // serverUrl: 'http://server.overrideeg.net:3001/v1',
  clientId: "Y29tLm92ZXJyaWRlZWcuYXBwcy5yZW1hdGMuaGF3emVu",
  contextURI: '',
  firebaseConfig: {
    apiKey: 'AIzaSyDfro2iaXjt6rA7zs7qXWHTSFoo86d2ZRc',
    authDomain: 'beautydoz.firebaseapp.com',
    databaseURL: 'https://beautydoz.firebaseio.com',
    projectId: 'beautydoz',
    storageBucket: 'beautydoz.appspot.com',
    messagingSenderId: '776775762569',
    appId: '1:776775762569:web:1e336a136910e51fff7c58',
    measurementId: 'G-PJPWXZPE25',
  }
};
